import { HttpClient } from '@angular/common/http';

import { Meta } from '@angular/platform-browser';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModuleConfig, } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppService } from './app.service';

export class MyMissingTranslationHandler implements MissingTranslationHandler {

  /**
   * Handle the Missing Translation value
   *
   * @param {MissingTranslationHandlerParams} params
   * @return {string}
   */
  public handle(params: MissingTranslationHandlerParams): string {
    return params.key;
  }
}

/**
 * HttpLoader Factory
 *
 * @param {HttpClient} http
 * @return {TranslateHttpLoader}
 * @constructor
 */
export function HttpLoaderFactory(http: HttpClient, meta: Meta) {
  return new TranslateHttpLoader(http, '/api/translation/lang/nl', '');
}

export const TRANSLATE_MODULE_CONFIG: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: (HttpLoaderFactory),
    deps: [HttpClient, AppService],
  },
  missingTranslationHandler: {provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler},
};
